import React, { useState } from 'react';

const Contact = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // This is a placeholder. In production send to your email/service.
    alert('Message submitted. Please configure a backend to receive messages.');
    setName('');
    setEmail('');
    setMessage('');
  };

  return (
    <div style={{ padding: 20, maxWidth: 800, margin: '0 auto' }}>
      <h1>Contact</h1>
      <p>If you have questions or need support, email <a href="mailto:support@pdfblink.com">support@pdfblink.com</a> or use the form below.</p>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <input placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} />
        <input placeholder="Your email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <textarea placeholder="Message" value={message} onChange={(e) => setMessage(e.target.value)} rows={6} />
        <button type="submit">Send Message</button>
      </form>
    </div>
  );
};

export default Contact;
